// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.table-search-bar {
  width: 220px !important;
  height: 2rem !important;
  border-top-right-radius: 2rem !important;
  border-bottom-right-radius: 2rem !important;
  overflow: hidden !important;
}

.search-icon {
  transition: 0.3s ease;
  color: rgb(102, 102, 102);
}

.tr-row-name {
  color: #0d6efd;
  font-weight: 600;
}

.header-theme {
  background-color: #f0f0f0;
  color: #111;
}

body[data-theme=dark] .module-perms-group {
  background-color: #1F1F1F;
}

body[data-theme=dark] .search-border {
  border: 1px solid #585858;
  border-radius: 1rem;
}

body[data-theme=dark] .search-icon {
  transition: 0.3s ease;
  color: #b0b0b0;
}

body[data-theme=dark] .tr-row-name {
  transition: 0.3s ease;
  color: #60a5fa;
}

body[data-theme=dark] .header-theme {
  background-color: #1f2937;
  color: #e2e8f0;
}`, "",{"version":3,"sources":["webpack://./src/assets/scss/custom/_tablesearch.scss"],"names":[],"mappings":"AAAA;EACI,uBAAA;EACA,uBAAA;EACA,wCAAA;EACA,2CAAA;EACA,2BAAA;AACJ;;AAEA;EACI,qBAAA;EACA,yBAAA;AACJ;;AAEA;EACI,cAAA;EACA,gBAAA;AACJ;;AAEA;EACI,yBAAA;EACA,WAAA;AACJ;;AAEA;EACI,yBAAA;AACJ;;AAEA;EACI,yBAAA;EACA,mBAAA;AACJ;;AAEA;EACI,qBAAA;EACA,cAAA;AACJ;;AAEA;EACI,qBAAA;EACA,cAAA;AACJ;;AAEA;EACI,yBAAA;EACA,cAAA;AACJ","sourcesContent":[".table-search-bar {\r\n    width: 220px !important;\r\n    height: 2rem !important; \r\n    border-top-right-radius: 2rem !important; \r\n    border-bottom-right-radius: 2rem !important; \r\n    overflow: hidden !important;\r\n}\r\n\r\n.search-icon {\r\n    transition: 0.3s ease;\r\n    color: rgb(102, 102, 102)\r\n}\r\n\r\n.tr-row-name {\r\n    color: #0d6efd;\r\n    font-weight: 600;\r\n}\r\n\r\n.header-theme {\r\n    background-color: #f0f0f0;\r\n    color: #111;\r\n}\r\n\r\nbody[data-theme=\"dark\"] .module-perms-group {\r\n    background-color: #1F1F1F ;\r\n}\r\n\r\nbody[data-theme=\"dark\"] .search-border {\r\n    border: 1px solid #585858ff;\r\n    border-radius: 1rem;\r\n}\r\n\r\nbody[data-theme=\"dark\"] .search-icon {\r\n    transition: 0.3s ease;\r\n    color: #b0b0b0\r\n}\r\n\r\nbody[data-theme=\"dark\"] .tr-row-name {\r\n    transition: 0.3s ease;\r\n    color:#60a5fa;\r\n}\r\n\r\nbody[data-theme=\"dark\"] .header-theme {\r\n    background-color: #1f2937;\r\n    color: #e2e8f0;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
